import { render, staticRenderFns } from "./TextFontSizeDesktop.vue?vue&type=template&id=47fdda52&scoped=true&"
import script from "./TextFontSizeDesktop.vue?vue&type=script&lang=ts&"
export * from "./TextFontSizeDesktop.vue?vue&type=script&lang=ts&"
import style0 from "./TextFontSizeDesktop.vue?vue&type=style&index=0&id=47fdda52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fdda52",
  null
  
)

export default component.exports